const datePickerValueToString = (value: unknown): string => {
  if (!value) return "";
  if (value instanceof Date) return value.toISOString().split("T")[0];
  return String(value);
};

export default datePickerValueToString;
